import SpriteSymbol from "../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "map-pin",
  "use": "map-pin-usage",
  "viewBox": "0 0 26 31",
  "content": "<symbol viewBox=\"0 0 26 31\" xmlns=\"http://www.w3.org/2000/svg\" id=\"map-pin\"><path d=\"m13 31c1.1430206 0 13-10.8202983 13-18 0-7.17970175-5.8202983-13-13-13-7.17970175 0-13 5.82029825-13 13 0 7.1797017 11.8569794 18 13 18z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol